import React, { useState } from "react";
import MainMenu from "../components/navigations/MainMenu";
import { BiChevronsDown } from "react-icons/bi";

export const StaffCard = ({ name, qualification, image, job }) => {
  return (
    <div className="md:border border-gray-400 rounded-md  p-2 w-80 h-40 overflow-hidden bg-gray-100 md:bg-transparent shadow-md md:shadow-none hover:bg-gray-100 cursor-pointer hover:border-transparent hover:shadow-md">
      <div>
        <div className="flex  justify-between">
          <img src={image} alt="profile" className="w-20 h-20 rounded-full" />
          <div>
            <p className="font-semibold font-serif text-gray-800">{name}</p>
            <p className="text-base text-gray-500">{qualification}</p>
          </div>
        </div>
        <div className="mt-2 ml-4">
          <ul className="text-xs list-disc">
            <li>{job}</li>
            <li>A small details about the teacher will be added here</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export const StaffLayout = ({ title, children }) => {
  const [toggle, setToggle] = useState(false);

  return (
    <div className="">
      <h1
        onClick={() => setToggle(!toggle)}
        className="flex items-center gap-x-2 text-xl font-semibold cursor-pointer"
      >
        <BiChevronsDown />
        {title}
      </h1>
      {toggle && (
        <div className="p-2 flex justify-center md:justify-between gap-y-2 flex-wrap">
          {children}
        </div>
      )}
    </div>
  );
};

const Teachers = () => {
  return (
    <div className="relative">
      <div className="absolute top-0 left-0">
        <MainMenu bg="gray-900" />
      </div>
      <div className="pt-20">
        <div className="p-2 md:p-8 md:px-32 flex flex-col justify-center">
          <h1 className="text-center text-2xl font-serif my-6">Our Staff</h1>
          {/** Staff 1 */}
          <StaffLayout title="Administrative Staff">
            <StaffCard
              name="Mr. Rudhamoy Debbarma"
              qualification="BA, MA"
              image="https://i.pravatar.cc/150?img=3"
              job="Teacher"
            />
            <StaffCard
              name="Mr. Nikhilesh Debbarma"
              qualification="B.Sc"
              image="https://i.pravatar.cc/150?img=4"
              job="Principal"
            />
            <StaffCard
              name="Mr. Ashish Debbarma"
              qualification="B.Ed, MA"
              image="https://i.pravatar.cc/150?img=5"
              job="Secretary"
            />
          </StaffLayout>
          {/** Staff 2 */}
          <StaffLayout title="Teaching Staff"></StaffLayout>

          {/** Staff 3 */}
          <StaffLayout title="Office Staff"></StaffLayout>

          {/** Staff 4 */}
          <StaffLayout title="Transport Staff"></StaffLayout>
        </div>
      </div>
    </div>
  );
};

export default Teachers;
